import { useContext, useState } from "react";

import { FlightAPIContext } from "contexts/flight_api_context";
import { useInterval } from "hooks/use_interval";

type TimeRemaining = {
  timeRemainingMs: number | null;
  timeRemainingString: string;
};

export const useTimeRemaining = (endTime: Date | null): TimeRemaining => {
  const flightAPI = useContext(FlightAPIContext);
  const [serverMilliseconds, setServerMilliseconds] = useState(flightAPI.getServerMilliseconds());

  useInterval(() => {
    setServerMilliseconds(flightAPI.getServerMilliseconds());
  }, 1000);

  if (!endTime) {
    return {
      timeRemainingMs: null,
      timeRemainingString: "0:00",
    };
  }

  const timeRemainingMs = endTime.getTime() - serverMilliseconds;

  const totalSeconds = Math.floor(Math.max(timeRemainingMs, 0) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const timeRemainingString = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

  return { timeRemainingMs, timeRemainingString };
};
